export function FormatNumbersTwoDigitsTwoDecimals(valor:number){
    return (valor.toLocaleString('en-US',{
        minimumIntegerDigits:2,
        minimumFractionDigits:2
    })
    );
}